import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Icon, IconButton } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { downloadFile } from '../../../utils/fileUtil'
import AppContext from '../../../context/AppContext'
import ListReportIssuesTable from './ListReportIssuesTable'
import ListReportIssuesSearchForm from './ListReportIssuesSearchForm'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import {
  downloadAuditSummaryIssueReportExcel,
  searchAuditSummaryIssueReport,
} from '../../../redux/actions/auditSummaryIssueReport'
import { cloneDeep } from 'lodash-es'

export default function AuditReportSummaryWidget(props) {
  const { theme } = React.useContext(AppContext)
  const { projectCode } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [searchRequest, setSearchRequest] = useState()
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  const [staExport, setStaExport] = useState()

  const onReload = (pageSize, pageNumber) => {
    // console.log('pageSize, pageNumber', pageSize, pageNumber)
    handleSearch(pageSize, pageNumber, searchRequest)
  }
  const onSearch = (request) => {
    // console.log('request', request)
    handleSearch(displayLength, 1, request)
  }

  const handleSearch = async (pageSize, pageNumber, request) => {
    setIsLoading(true)
    startLoading()
    try {
      // let _request = {
      //   ...request,
      //   pageNumber: pageNumber,
      //   pageSize: pageSize
      // }
      console.log('request', request)

      setPage(pageNumber)
      setDisplayLength(pageSize)
      setSearchRequest(request)

      const response = await searchAuditSummaryIssueReport(request, pageNumber, pageSize)
      if (response) {
        let _schema = cloneDeep(formSchema)

        _schema.result = response.model
        setFormSchema(_schema)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      doneLoading()
      setIsLoading(false)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleExportFile = async (request, pageSize, pageNumber) => {
    setIsLoading(true)
    startLoading()
    try {
      let _request = {
        ...request,
        pageNumber: pageNumber,
        pageSize: pageSize,
      }
      const file = await downloadAuditSummaryIssueReportExcel(_request)

      if (file) {
        downloadFile(file, file.name || `รายงานสรุปประเด็นตรวจพบ`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setStaExport(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleOnExport = (data) => {
    handleExportFile(data, displayLength, page)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        {formSchema && (
          <div style={{ marginTop: 0 }}>
            <ListReportIssuesSearchForm
              schema={formSchema?.searchForm}
              onSearch={onSearch}
              onExport={handleOnExport}
              isExport={staExport}
              loading={isLoading}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </div>
        )}
        <hr />

        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="print" className="bt-gost-icon-radius" />}
              onClick={() => {
                // handleOnExport()
                setStaExport(true)
                // console.log('xxxx')
              }}
            >
              Export
            </IconButton>
          </Col>
        </Row>

        {isLoading && <OverlayLoader />}

        {formSchema?.result && (
          <ListReportIssuesTable
            schema={formSchema}
            loading={isLoading}
            onReload={onReload}
            // page={page}
            // displayLength={displayLength}
            pagination
          />
        )}
      </Panel>
    </>
  )
}
